import { render, staticRenderFns } from "./CopyAccountConsignee.vue?vue&type=template&id=819dbe6c&scoped=true"
import script from "./CopyAccountConsignee.vue?vue&type=script&lang=js"
export * from "./CopyAccountConsignee.vue?vue&type=script&lang=js"
import style0 from "./CopyAccountConsignee.vue?vue&type=style&index=0&id=819dbe6c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819dbe6c",
  null
  
)

export default component.exports